import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DealersService, IDealersInfo } from '@ztarmobile/zwp-service-backend';
import { MetaService } from '../../../services/meta-service.service';
import { ToastrHelperService } from '../../../services/toast-helper.service';
import { CAPTCHA_BOT_ERROR_CODE, EMAIL_PATTERN, NAME_PATTERN, Phone_PATTERN } from 'src/app/app.config';
import { Subscription } from 'rxjs';
import { AppState } from '@app/app.service';
import { ModalHelper } from '@services/modal-helper.service';

@Component({
  selector: 'app-dealers',
  templateUrl: './dealers.component.html',
  styleUrls: ['./dealers.component.scss']
})
export class DealersComponent implements OnDestroy {
  public dealerForm: FormGroup;
  public dealersInfo: IDealersInfo = {} as IDealersInfo;
  public recaptchaResolvedSubscription: Subscription;
  public captchaResponse;
  public processingRequest = false;
  public showingExtraContent = false;

  constructor(private formBuilder: FormBuilder,
    private toastHelper: ToastrHelperService,
    private metaService: MetaService,
    private dealersService: DealersService, private appState: AppState, private modalHelper: ModalHelper) {
    this.dealerForm = formBuilder.group({
      fname: ['', Validators.compose([Validators.required, Validators.pattern(NAME_PATTERN)])],
      lname: ['', Validators.compose([Validators.required, Validators.pattern(NAME_PATTERN)])],
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_PATTERN)])],
      phone: ['', Validators.compose([Validators.required, Validators.pattern(Phone_PATTERN)])],
      storeName: ['', Validators.required]
    });
    this.metaService.createCanonicalUrl();
  }

  ngOnDestroy(): void {
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }
  public sendMessage(): void {
    this.dealerForm.markAllAsTouched();
    const action = 'freeup_send_store_info';

    if (this.dealerForm.valid) {
      this.appState.loading = true;
      this.processingRequest = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.captchaResponse = response;
        if(!!this.captchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callSendStoreInfo(this.captchaResponse, true, action);
        }
      });
    }
  }
  public callSendStoreInfo(captchaRes, invisibleCaptchaRes, action?): void {
    this.dealersInfo.firstName = this.dealerForm.get('fname').value;
    this.dealersInfo.lastName = this.dealerForm.get('lname').value;
    this.dealersInfo.storeName = this.dealerForm.get('storeName').value;
    this.dealersInfo.email = this.dealerForm.get('email').value;
    this.dealersInfo.phone = this.dealerForm.get('phone').value;
    this.dealersService.sendStoreInfo(this.dealersInfo,captchaRes,!!action? action: null, invisibleCaptchaRes).then(() => {
      this.processingRequest = false;
      this.appState.loading = false;
      this.toastHelper.showSuccess('Thank You ' + this.dealersInfo.firstName + ' ' + this.dealersInfo.lastName);
      window.location.replace(this.formLandingLink());
      this.dealersInfo = {} as IDealersInfo;
    }).catch((error) => {
      this.processingRequest = false;
      this.appState.loading = false;
      if(error?.error?.code === CAPTCHA_BOT_ERROR_CODE) {
        this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result)=> {
          if(!!result) {
            this.processingRequest = true;
            this.appState.loading = true;
            this.callSendStoreInfo(result, false);
          }
        });
       } else {
        this.toastHelper.showAlert(error?.error?.message);
      }
      this.recaptchaResolvedSubscription?.unsubscribe();
    });
  }
  public formLandingLink(): string {
    return this.dealersService.getMailChimpUrl(this.dealersInfo);
  }

}
